import { memo, useState, useEffect } from 'react';
import '../../styles/variables.css';

import web_logo from '../../assets/logo_green.png';

// Define props interface including the modal control function
interface AppLogoProps {
  onLogoClick: () => void;
  isMobile?: boolean;
  switchInterval?: number; // Time in ms between logo switches, optional
}

// Create an array of all logo imports
const logoOptions = [web_logo]; // Add all logo variations here

// Memoize the component to prevent unnecessary re-renders
const AppLogo = memo(
  ({ onLogoClick: _onLogoClick, isMobile = false, switchInterval = 10000 }: AppLogoProps) => {
    // State to track the current logo
    const [currentLogo, setCurrentLogo] = useState(logoOptions[0]);

    // Effect to handle logo switching on an interval
    useEffect(() => {
      // Function to select a random logo that's different from the current one
      const getRandomLogo = () => {
        // Filter out the current logo to avoid showing the same one twice in a row
        const availableLogos = logoOptions.filter(logo => logo !== currentLogo);

        // If we somehow only have one logo, return it
        if (availableLogos.length === 0 && logoOptions.length > 0) {
          return logoOptions[0];
        }

        // Pick a random logo from the available options
        const randomIndex = Math.floor(Math.random() * availableLogos.length);
        return availableLogos[randomIndex];
      };

      // Only set up the interval if we have more than one logo and a positive interval
      if (logoOptions.length > 1 && switchInterval > 0) {
        const intervalId = setInterval(() => {
          setCurrentLogo(getRandomLogo());
        }, switchInterval);

        // Clean up the interval when the component unmounts or when interval changes
        return () => clearInterval(intervalId);
      }
    }, [currentLogo, switchInterval]);

    return (
      <div
        className={`flex items-center h-full ${isMobile ? 'mobile-scale' : ''}`}
        style={{ paddingTop: '8px', paddingBottom: '8px' }}
      >
        {/* Logo and Live indicator */}
        <div className="relative flex items-center">
          <img
            src={currentLogo}
            alt="ceen"
            className="logo-element h-[var(--logo-height)] w-auto object-contain cursor-pointer scale-125 pl-2"
            // onClick={onLogoClick}
          />
        </div>
      </div>
    );
  }
);

AppLogo.displayName = 'AppLogo';

export default AppLogo;
